<obg-session-timer-container timerText="dga.timer.session.text"></obg-session-timer-container>
<div class="logo-text">
	<a [href]="'general.dga-logo-link' | translate" target="_blank">
		<span>{{ "general.danish.regulator" | translate }}</span>
		<img obgImageContent="general.dga-logo" />
	</a>
</div>
<img *ngIf="inGame" class="brand-logo" obgImageContent="general.brand-logo" />
